import React, { useState, lazy, Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import './App.css'
import { About } from './Components/About/About'
import Footer from './Components/Footer/Footer'
import { Home } from './Components/Home/Home'
import MovieDetail from './Components/MovieDetail/MovieDetail'
import { Navbar } from './Components/Navbar/Navbar'
import { SignIn } from './Components/SignIn/SignIn'

// const HomePage = lazy(() => import('./pages/home/index'));
// const LogInPage = lazy(() => import('./pages/auth/LogIn'))
// const RegisterPage = lazy(() => import('./pages/auth/Register'))

export function App() {
    // const [token, setToken] = useState(window.localStorage.getItem('token'));
    return (


        // <Suspense fallback={<h1>Error code</h1>}>
        //     <Router>
        //         <Switch>
        //             {
        //                 token ? (
        //                     <Route exact path="/" component={HomePage} />
        //                 ) : (
        //                     <Route exact path="/" render={() => <LogInPage setToken={setToken} />} />
        //                 )
        //             }
        //         </Switch>
        //     </Router>
        // </Suspense>


        <main>
            <Navbar />
            <Switch>
                <Route exact path='/about' component={About} />
                <Route path="/" component={Home} exact />
                <Route exact path="/movie/:id" component={MovieDetail} />
                <Route path="/login" component={SignIn} exact />
            </Switch>
            <Footer />
        </main>

    )
}

export default App

